// extracted by mini-css-extract-plugin
export default {"divider":"Toolbar-module__divider--uW6mE","toolbar":"Toolbar-module__toolbar--CkIKP"};